import { reducerWithInitialState } from 'typescript-fsa-reducers'

import UIState from '../states/UIState'
import { Router, Toolbar } from '../actions'
import { matchPhotoRoute } from '../states/RouterState'

export const initialState: UIState = {
  showDialogue: true,
  showSignUpPromoteModal: false,
  photoID: undefined
}

export default reducerWithInitialState(initialState)
  .case(Toolbar.toggleDialogue, state => ({
    ...state,
    showDialogue: !state.showDialogue
  }))
  .case(Toolbar.showSignUpPromoteModal, state => ({
    ...state,
    showSignUpPromoteModal: true
  }))
  .case(Toolbar.closeSignUpPromoteModal, state => ({
    ...state,
    showSignUpPromoteModal: false
  }))
  .case(Toolbar.signUpPromoteTapped, state => ({
    ...state,
    showSignUpPromoteModal: false
  }))
  .case(Router.locationChange, (state, location) => {
    const match = matchPhotoRoute(location.pathname)
    if (!match) {
      return {
        ...state,
        photoID: undefined
      }
    }
    return {
      ...state,
      photoID: match.params.id
    }
  })
  .build()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/ui.ts